/**
 * m3 echo Frontend - Impressum Page
 *
 * Public legal notice page (no authentication required).
 */

import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import {
  Box,
  Card,
  CardContent,
  Typography,
  Divider,
  Link,
  Button,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export const Impressum: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        p: 3,
      }}
    >
      <Card sx={{ maxWidth: 600, width: '100%' }}>
        <CardContent sx={{ p: 4 }}>
          <Button
            component={RouterLink}
            to="/login"
            startIcon={<ArrowBackIcon />}
            sx={{ mb: 2 }}
          >
            Zurück
          </Button>

          <Typography variant="h4" fontWeight={700} gutterBottom>
            Impressum
          </Typography>

          <Divider sx={{ mb: 3 }} />

          <Typography variant="h6" fontWeight={600} gutterBottom>
            m3 management consulting GmbH
          </Typography>
          <Typography variant="body1" gutterBottom>
            Robert-Bürkle-Straße 1<br />
            85737 Ismaning
          </Typography>

          <Typography variant="body1" sx={{ mt: 2 }} gutterBottom>
            Telefon: +49 89 1392850-0<br />
            Fax: +49 89 1392850-13<br />
            E-Mail:{' '}
            <Link href="mailto:info@m3maco.com">info@m3maco.com</Link>
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="subtitle2" fontWeight={600} gutterBottom>
            Geschäftsführer
          </Typography>
          <Typography variant="body2" gutterBottom>
            Michael Dusch (Vorsitzender), Karsten Redenius, Dr. Christof Spangenberg
          </Typography>

          <Typography variant="subtitle2" fontWeight={600} sx={{ mt: 2 }} gutterBottom>
            Registergericht
          </Typography>
          <Typography variant="body2" gutterBottom>
            Amtsgericht München, HRB 179792
          </Typography>

          <Typography variant="subtitle2" fontWeight={600} sx={{ mt: 2 }} gutterBottom>
            Umsatzsteuer-Identifikationsnummer
          </Typography>
          <Typography variant="body2" gutterBottom>
            DE 265 548 286
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="subtitle2" fontWeight={600} gutterBottom>
            Verantwortlich nach § 18 Abs. 2 MStV
          </Typography>
          <Typography variant="body2" gutterBottom>
            Michael Dusch, Geschäftsführer (Vorsitzender)<br />
            Robert-Bürkle-Straße 1, 85737 Ismaning
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="body2" color="text.secondary">
            Die m3 management consulting GmbH ist ein Unternehmen der msg-Gruppe,
            einer unabhängigen, internationalen Unternehmensgruppe mit eigenständigen
            Gesellschaften und über 10.000 Mitarbeitenden.
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="body2" color="text.secondary">
            Diese Webseite nutzt Open-Source-Software.{' '}
            <Link component={RouterLink} to="/lizenzen">
              Eine vollständige Liste der Lizenzen finden Sie hier
            </Link>.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Impressum;
